// extracted by mini-css-extract-plugin
module.exports = {"top":"Wallet_top__3b-AI","bottom":"Wallet_bottom__GvmpA","tableContainer":"Wallet_tableContainer__39ntA","table":"Wallet_table__2JEXJ"};